import React, { useEffect } from 'react';
import { Typography } from 'antd';
import { Volume2 } from 'lucide-react';
import { AccessibleButton } from './AccessibleButton';
import { AccessibleImage } from './AccessibleImage';
import { useMissionState } from '../hooks/useMissionState';
import type { MissionWithRelations } from '../types/database';

const { Title, Paragraph } = Typography;

interface MissionCardProps {
  setHidden:any;
  hidden:any;
  mission: MissionWithRelations;
  onStartMission?: () => void;
}

export const MissionCard: React.FC<MissionCardProps> = ({
  setHidden,
  hidden,
  mission,
  onStartMission
}) => {
  const { startMission } = useMissionState();
  
  // const handleAudioClick = () => {
    //   // TODO: Implémenter la lecture audio
    //   console.log('Lecture audio:', mission.audiodescription);
    // };
    
    const handleStartClick = () => {
      
    startMission();
    setHidden(!hidden)
    console.log("hidden card",hidden);
    
    if (onStartMission) {
      onStartMission();
    }
  };

  return (
    <div className="bg-blue-50 rounded-2xl p-6 h-max">
      <div className="flex gap-4">
        {/* Colonne Gauche pour frise discussion et avatar */}
        <div className="flex flex-col items-center justify-center gap-2">
          <AccessibleImage
            src={mission.mascotte.avatar}
            altKey="images.mascotteAvatar"
            className="w-16 h-16 min-w-16 min-h-16 rounded-full border-2 border-primary-600 bg-white"
          />
          <div className="h-full w-1 -ml-1 border-r-2 border-dashed border-primary-600" />
        </div>
        {/* Colonne Droite avec contenu du message */}
        <div className="flex flex-col h-full gap-2 mb-5">
          <div className="flex items-center gap-3">
            <div className="flex justify-between items-center w-full">
              <Title level={4} className="ant-typography !text-lg !font-semibold !mb-1 !text-primary-600 css-dev-only-do-not-override-63ah2z">
                {mission.mascotte.nom} :
              </Title>
              {/* V2 */}
              {/* <button
                onClick={handleAudioClick}
                className="flex items-center gap-2 text-primary-600 font-semibold hover:text-primary-800 text-md underline bg-transparent border-none cursor-pointer"
                aria-label="Écouter le message audio"
              >
                <Volume2 className="w-4 h-4" />
                Lire le message
              </button> */}
            </div>
          </div>

          {/* Message principal */}
          <div className="flex-1">
            {
              mission.numeroMission === 1 &&
            <Paragraph className="!text-base !leading-relaxed !text-neutral-700 !mb-4">
              {mission.starting} <strong>Andy K.</strong>
            </Paragraph>

            }
            <Paragraph className="!text-base !leading-relaxed !text-neutral-700 !mb-4">
              {mission.description}
            </Paragraph>
            
            <div className="">
              <strong className="text-base text-neutral-900 block mb-2">
                Ta mission si tu l'acceptes :
              </strong>
              <div className="bg-blue-100 border border-primary-200 rounded-lg p-4 border-1 border-primary-400">
                <Paragraph className="!text-base !mb-0 !text-neutral-800">
                  Sur l'écran qui va apparaître ci-contre, <strong>{mission.mission}</strong>
                </Paragraph>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-4 items-center">
        {/* Colonne Gauche pour frise discussion et avatar */}
        <div className="flex flex-col items-center justify-center gap-2">
          <AccessibleImage
            src='/img/mascottes/andy-k-avatar.png'
            altKey="images.mascotteAvatar"
            className="w-16 h-16 min-w-16 min-h-16 rounded-full border-2 border-primary-600 bg-white mt-2"
          />
        </div>
        {/* Colonne Droite avec contenu du message */}
        <div className="flex flex-col gap-2">
          {/* Bouton d'action */}
          <div className="mt-auto">
            <AccessibleButton
              type="primary"
              onClick={handleStartClick}
              className="!w-max !p-4"
              ariaLabelKey="buttons.startMission"
              style={{display:!hidden?'none':''}}
            >
              Accepter et démarrer la mission
            </AccessibleButton>
            <span style={{display:hidden?'none':''}}>✔️ Mission acceptée</span>
          </div>
        </div>
      </div>
    </div>
  );
};